"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchContentByQuery = exports.fetchContentByEntryId = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _polarisServerCaching = require("@noths/polaris-server-caching");
var _stack = require("./stack");
var _types = require("./types");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var fetchPromises = {};
var logError = function logError(config, error) {
  var env = config.env,
    logger = config.logger,
    stackName = config.stackName;
  if (logger) {
    logger.error('error fetching content from Contentstack', {
      env,
      stackName,
      error
    });
  }
};
var fetchContentWithCaching = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(config, cacheOptions, fetchFn) {
    var cacheClient, cacheKey, cacheTTLInSeconds, cachedEntry;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          cacheClient = (0, _polarisServerCaching.createCacheClient)();
          cacheKey = cacheOptions.cacheKey, cacheTTLInSeconds = cacheOptions.cacheTTLInSeconds;
          _context.next = 4;
          return cacheClient === null || cacheClient === void 0 ? void 0 : cacheClient.getByKey(cacheKey, cacheTTLInSeconds);
        case 4:
          cachedEntry = _context.sent;
          if (!(cachedEntry && cachedEntry.status === _polarisServerCaching.CACHE_STATUS_FRESH)) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", Promise.resolve({
            content: cachedEntry.data,
            status: 'fresh'
          }));
        case 9:
          if (!fetchPromises[cacheKey]) {
            _context.next = 11;
            break;
          }
          return _context.abrupt("return", fetchPromises[cacheKey]);
        case 11:
          fetchPromises[cacheKey] = fetchFn().then(function (content) {
            fetchPromises[cacheKey] = null;
            cacheClient === null || cacheClient === void 0 || cacheClient.setByKey(cacheKey, content);
            return {
              content,
              status: 'fresh'
            };
          }).catch(function (error) {
            logError(config, error);
            fetchPromises[cacheKey] = null;
            if (cachedEntry) {
              return {
                content: cachedEntry.data,
                status: 'expired'
              };
            } else {
              return {
                content: error,
                status: 'error'
              };
            }
          });
          return _context.abrupt("return", fetchPromises[cacheKey]);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchContentWithCaching(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var fetchContentWithoutCaching = function fetchContentWithoutCaching(config, fetchFn) {
  return fetchFn().then(function (content) {
    return {
      content,
      status: 'fresh'
    };
  }).catch(function (error) {
    logError(config, error);
    return {
      content: error,
      status: 'error'
    };
  });
};
var allowCaching = function allowCaching(_ref2) {
  var env = _ref2.env;
  return env !== _types.Environment.Preview;
};
var getCacheKey = function getCacheKey(_ref3, contentType, suffix) {
  var env = _ref3.env,
    stackName = _ref3.stackName;
  return [env, stackName, contentType, suffix].join('-');
};
var fetchContentByEntryId = exports.fetchContentByEntryId = function fetchContentByEntryId(config, contentType, entryId, cacheOptions, params) {
  var env = config.env,
    stackName = config.stackName;
  var fetchFn = function fetchFn() {
    return (0, _stack.fetchStackEntry)({
      env,
      stackName,
      contentType,
      entryId,
      include: params === null || params === void 0 ? void 0 : params.include,
      only: params === null || params === void 0 ? void 0 : params.only
    });
  };
  if (allowCaching(config)) {
    var cacheConfig = _objectSpread(_objectSpread({}, cacheOptions), {}, {
      cacheKey: getCacheKey(config, contentType, entryId)
    });
    return fetchContentWithCaching(config, cacheConfig, fetchFn);
  }
  return fetchContentWithoutCaching(config, fetchFn);
};
var fetchContentByQuery = exports.fetchContentByQuery = function fetchContentByQuery(config, contentType, query, cacheOptions, params) {
  var env = config.env,
    stackName = config.stackName;
  var fetchFn = function fetchFn() {
    return (0, _stack.fetchStackQuery)({
      env,
      stackName,
      contentType,
      query,
      include: params === null || params === void 0 ? void 0 : params.include,
      only: params === null || params === void 0 ? void 0 : params.only
    });
  };
  if (allowCaching(config)) {
    var cacheConfig = _objectSpread(_objectSpread({}, cacheOptions), {}, {
      cacheKey: getCacheKey(config, contentType, JSON.stringify(query))
    });
    return fetchContentWithCaching(config, cacheConfig, fetchFn);
  }
  return fetchContentWithoutCaching(config, fetchFn);
};